var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4447 4.68435C17.4447 4.89786 17.4447 5.00461 17.4447 5.21811C17.4447 10.2354 13.7298 16 6.93684 16C4.92017 16 2.90351 15.4662 1.3114 14.292C1.62982 14.292 1.94824 14.3987 2.16052 14.3987C3.85877 14.3987 5.45087 13.865 6.72456 12.7975C5.13245 12.7975 3.75263 11.7299 3.22193 10.1287C3.75263 10.1287 4.38947 10.1287 4.92017 9.91517C3.22193 9.59492 1.94824 7.99365 1.94824 6.28562C2.47894 6.60588 3.00965 6.71263 3.64649 6.71263C2.05438 5.64512 1.52368 3.40334 2.47894 1.69531C4.38947 4.04385 7.14912 5.43161 10.121 5.53836C9.80263 4.25735 10.2272 2.86958 11.1825 2.01557C12.6684 0.627801 15.0035 0.627801 16.3833 2.22907C17.2325 2.01557 17.9754 1.80207 18.7184 1.26831C18.4 2.12232 17.8693 2.86958 17.1263 3.40334C17.8693 3.29659 18.6123 3.08308 19.2491 2.76283C18.7184 3.51009 18.0816 4.1506 17.4447 4.68435Z",
    stroke: "#00B2B1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.70218595.svg";
export { ForwardRef as ReactComponent };